module.exports = require('./helpers/bundle-url').getBundleURL('cNbFg') + "logo-dark.eefe0b7f.svg";